import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";
import Select from "react-select";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { getAllEntity, getEntity, getOneEntity, getTaskById, updateTask } from "http/fundLync/entityAndAddress.helper";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import ToastDialog from "components/Common/ToastDialog";
import * as Yup from "yup";
import { Formik } from "formik";
import { getEntityWiseDeal } from "http/fundLync/deal.helper";
import { callGetCIUser } from "http/fundLync/dealFinancier";
import { decryptedValue } from "common/utility";

const UpdateTask = () => {
  const { id } = useParams();
  const Id = atob(id);
  const navigate = useNavigate();
  const [toastInfo, setToastInfo] = useState({ showToast: false, message: "", role: "" });
  const currentDate = new Date().toISOString().split("T")[0];
  const [typeList, setTypeList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [priorityList, setPriorityList] = useState([]);
  const [reminderList, setReminderList] = useState([]);
  const [entityList, setEntityList] = useState([]);
  const [dealList, setDealList] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState('');
  const [dealAuthorList, setDealAuthorList] = useState([]);
  const [selectedDealAuthor, setSelectedDealAuthor] = useState("");
  const [hasOpenedBefore, setHasOpenedBefore] = useState(true);

  const [initialValues, setInitialValues] = useState({
    id: "",
    entityId: "",
    dealId:"",  
    taskName: "",
    taskType: "",
    taskDescription: "",
    taskStatus: "",
    taskPriority: "",
    dueDate: "",
    dueTime: "",
    taskReminder: "",
    assignedTo : "",
  });
  const user = decryptedValue(localStorage.getItem("user"));

  const validationSchema = Yup.object({
    taskName: Yup.string().required("Task Name is required"),
  });

  useEffect(() => {
    callGetCIUser()
      .then((res) => {
        setDealAuthorList(res.data.rows)
      })
      .catch((error) => {})

    getTaskById({ Id })
      .then((response) => {
        const formattedDate = response.dueDate.split(" ")[0];
        setInitialValues({
          id: response.id,
          entityId: response.entityId,
          dealId: response.dealId, 
          taskName: response.taskName,
          taskType: response.taskType,
          taskDescription: response.taskDescription,
          taskStatus: response.taskStatus,
          taskPriority: response.taskPriority,
          dueDate: formattedDate,
          dueTime: response.dueTime,
          taskReminder: response.taskReminder,
          assignedTo: response.assignedTo
        });
        setSelectedDealAuthor(response.assignedTo)
      })
      .catch((error) => {
        console.log(error);
      });

    getDropDownList({ dropdownName: "Task_Type" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName === "Task_Type")
            ?.dropdownValues || [];
        setTypeList(dropdownValues);
      })
      .catch((error) => {
        console.log("Error fetching data", error);
      });

    getDropDownList({ dropdownName: "Task_Status" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName === "Task_Status")
            ?.dropdownValues || [];
        setStatusList(dropdownValues);
      })
      .catch((error) => {
        console.log("Error fetching data", error);
      });

    getDropDownList({ dropdownName: "Task_Priority" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName === "Task_Priority")
            ?.dropdownValues || [];
        setPriorityList(dropdownValues);
      })
      .catch((error) => {
        console.log("Error fetching data", error);
      });

    getDropDownList({ dropdownName: "Reminder" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName === "Reminder")
            ?.dropdownValues || [];
        setReminderList(dropdownValues);
      })
      .catch((error) => {
        console.log("Error fetching data", error);
      });

      let totalValues;
      getEntity()
       .then((response) =>{
        totalValues = response.data.totalItems; 
          getEntity({limit:totalValues})
          .then((response) => {
              setEntityList(response?.data?.data);
          })
          .catch((error) => {
            console.log(error)
          })
       }) 
      .catch((error) => {
        console.log(error)
      })
  }, [Id]);

  useEffect(() => {
    if (initialValues.entityId) {
      getOneEntity({ entityId: initialValues.entityId })
        .then((response) => {
          if (response.code === 200 && response.status) {
            setSelectedEntity(response.data[0]);
          }
        })
        .catch((error) => {
          console.error(error);
        });

      getEntityWiseDeal({ entityId: initialValues.entityId })
        .then((response) => {
          if (response?.data?.rows.length > 0) {
            setDealList(response.data.rows);
          } else {
            setDealList([]);
          }
        })
        .catch((error) => {
          console.error(error);
          setDealList([]);
        });
    }
  }, [initialValues.entityId]);

  const handleEntityChange = (event) => {
    const newEntityId = event.target.value;
    setInitialValues({ ...initialValues, entityId: newEntityId });

    getEntityWiseDeal({ entityId: newEntityId })
      .then((response) => {
        if (response?.data?.rows.length > 0) {
          setDealList(response.data.rows);
        } else {
          setDealList([]);
        }
      })
      .catch((error) => {
        console.error(error);
        setDealList([]);
      });
  };

  const handleInputChangeForDealAuthor = (value) => {
    callGetCIUser()
      .then((response) => {
        setDealAuthorList(response.data.rows)
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSave = (values) => {
    const updatedTask = {
      id: Id,
      entityId: values.entityId,
      dealId: values.dealId,
      taskName: values.taskName,
      taskType: values.taskType,
      taskDescription: values.taskDescription,
      taskStatus: values.taskStatus,
      taskPriority: values.taskPriority,
      dueDate: values.dueDate,
      dueTime: values.dueTime,
      taskReminder: values.taskReminder,
      assignedTo: values.assignedTo
    };

    updateTask(updatedTask)
      .then((response) => {
        setToastInfo({
          message: "Details Updated Successfully",
          showToast: true,
          role: "success",
        });
        setTimeout(() => {
          navigate(-1);
        }, 2000);

      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCancel = () => {
    navigate(-1);
  };
  const capitalizeFirstLetter = (inputString) => {
    if (typeof inputString !== 'string' || inputString.length === 0) {
      return inputString;
    }
    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Update Task" />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSave}
                    enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="title">Entity Name</Label>
                            <Input
                              type="select"
                              name="entityId"
                              value={values.entityId}
                              onChange={(e) => {
                                handleChange(e);
                                handleEntityChange(e);
                              }}
                            >
                              {entityList.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.entityName}
                                </option>
                              ))}
                            </Input>
                          </Col>
                          {dealList?.length > 0 && (<Col sm="6">
                            <Label for="title">Deal Name</Label>
                            <Input
                              type="select"
                              name="dealId"
                              value={values.dealId}
                              onChange={handleChange}
                            >
                              {dealList?.length > 0 ?(
                                <option value="">
                                  Select Deal
                                </option>
                              ):(
                                <option value="">
                                  No Deals Found
                                </option>
                              )}
                              
                              {dealList.map((item) => (
                                
                                <option key={item.id} value={item.id}>
                                  {item.dealName}
                                </option>
                              ))}
                            </Input>
                          </Col>)}
                        </Row>
                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="title">Task Name*</Label>
                            <Input
                              type="text"
                              name="taskName"
                              value={values.taskName}
                              onChange={handleChange}
                              invalid={touched.taskName && !!errors.taskName}
                            />
                            {touched.taskName && errors.taskName && (
                              <FormFeedback>{errors.taskName}</FormFeedback>
                            )}
                          </Col>
                          <Col sm="6">
                            <Label for="date">Task Type</Label>
                            <Input
                              type="select"
                              name="taskType"
                              value={values.taskType}
                              onChange={handleChange}
                            >
                              {typeList.map((type) => (
                                <option key={type.id} value={type.dropdownValue}>
                                  {type.displayName}
                                </option>
                              ))}
                            </Input>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="description">Task Reminder</Label>
                            <Input
                              type="select"
                              name="taskReminder"
                              value={values.taskReminder}
                              onChange={handleChange}
                            >
                              {reminderList.map((reminder) => (
                                <option key={reminder.id} value={reminder.dropdownValue}>
                                  {reminder.displayName}
                                </option>
                              ))}
                            </Input>
                          </Col>

                          <Col sm="6">
                            <Label for="date">Task Status</Label>
                            <Input
                              type="select"
                              name="taskStatus"
                              value={values.taskStatus}
                              onChange={handleChange}
                            >
                              {statusList.map((status) => (
                                <option key={status.id} value={status.dropdownValue}>
                                  {status.displayName}
                                </option>
                              ))}
                            </Input>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="description">Task Priority</Label>
                            <Input
                              type="select"
                              name="taskPriority"
                              value={values.taskPriority}
                              onChange={handleChange}
                            >
                              {priorityList.map((priority) => (
                                <option key={priority.id} value={priority.dropdownValue}>
                                  {priority.displayName}
                                </option>
                              ))}
                            </Input>
                          </Col>
                          <Col sm="6">
                            <Label for="description">Due Date</Label>
                            <Input
                              type="date"
                              name="dueDate"
                              value={values.dueDate}
                              onChange={handleChange}
                              min={currentDate}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="description">Due Time</Label>
                            <Input
                              type="time"
                              name="dueTime"
                              value={values.dueTime}
                              onChange={handleChange}
                            />
                          </Col>

                          <Col sm="6">
                            <Label className="form-label text-start d-block">
                            Assign User 
                            </Label>
                              <Input
                                name="assignedTo"
                                type="select"
                                onChange={handleChange}
                                value={values.assignedTo || null}
                                invalid={
                                  touched.assignedTo && errors.assignedTo
                                }
                              >
                                <option value="" >Select User</option>
                                {dealAuthorList?.map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {capitalizeFirstLetter(option.firstName) + ' ' + ((option.lastName) ? capitalizeFirstLetter(option.lastName) : '')}
                                  </option>
                                ))}

                              </Input>
                              {touched.assignedTo && errors.assignedTo ? (
                                <FormFeedback type="invalid">
                                  {errors.assignedTo}
                                </FormFeedback>
                              ) : null}
                          </Col>

                          
                        </Row>
                        <Row className="mb-3">
                        <Col sm="12">
                            <Label for="date">Task Description</Label>
                            <Input
                              type="textarea"
                              name="taskDescription"
                              value={values.taskDescription}
                              onChange={handleChange}
                            />
                          </Col>
                        </Row>

                        <div className="d-flex justify-content-end">
                          <Button type="submit" style={{ backgroundColor: '#21aa47', borderColor: '#21aa47' }} className="me-2">
                            Save
                          </Button>
                          <Button type="button" 
                            onClick={handleCancel}
                            outline
                            >
                            Cancel
                          </Button> 
                        </div>
                      </Form>
                    )}
                  </Formik>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default UpdateTask;